import React, { Component } from 'react';
import Fuse from 'fuse.js';

import { ReactComponent as CloseIcon } from '../../ds/icons/svg/ontario-icon-close.svg';

import './fuzySearch.scss';
const noop = () => {};

// default settings
const defaultoptions = {
  shouldSort: true,
  threshold: 0.6,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  findAllMatches: false,
  keys: ['id'],
};

class FuzySearch extends Component {
  //intialize the constructor
  constructor(props) {
    super(props);
    // console.log("{ ...defaultoptions, ...this.props.searchSettings }", {
    //   ...defaultoptions,
    //   ...this.props.searchSettings,
    // });
    this.myInput = React.createRef();
    this.state = {
      searchData: [],
      searchQuery: this.props.searchQuery,
      fuse: new Fuse(this.props.data, {
        ...defaultoptions,
        ...this.props.searchSettings,
      }),
    };
  }

  componentDidMount() {
    // console.log(this.myInput.current.offsetWidth);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState(
        {
          fuse: new Fuse(this.props.data, {
            ...defaultoptions,
            ...this.props.searchSettings,
          }),
        },
        () => {
          this.searchAndReturnResults(this.state.searchQuery);
        },
      );
    }

    if (prevProps.searchQueryTime !== this.props.searchQueryTime) {
      const searchQuery = this.props.searchQuery;

      const visibleChars = Math.ceil(
        this.myInput.current.offsetWidth / 10.5,
      );

      //21 if width is 320
      this.setState({
        searchQuery:
          searchQuery.length < visibleChars
            ? searchQuery
            : searchQuery.slice(0, visibleChars) + '...',
      });
    }
  }

  checkMinSearchLength = (e) =>
    e && e.length && e.length >= this.props.minSearchLength;

  searchAndReturnResults = (e) => {
    var results;
    if (this.checkMinSearchLength(e)) {
      this.props.searchResultsStartCallback();
      results = this.state.fuse.search(e);
    }
    this.updateInputValue(e);

    this.props.searchResultsCallback(e, results ? results : []);
  };

  updateInputValue = (e) => {
    this.setState({ searchQuery: e });
  };

  clearSearch = () => {
    this.setState({ searchQuery: '' });
    this.props.searchResultsCallback('', []);
  };

  render() {
    const uniqueDate = +new Date();
    return (
      <div className={'center-items'}>
        {this.props.label && (
          <label
            style={{
              margin: '0px 8px 0px 0px',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
            }}
            className={this.props.class}
            htmlFor={`phu-fuzzy-search-${uniqueDate}`}
          >
            {this.props.label}
          </label>
        )}

        <div className="fuzy-search-container container">
          <input
            ref={this.myInput}
            onFocus={() => {
              this.props.onFocus();
              if (this.props.searchOnFocus) {
                this.searchAndReturnResults(this.state.searchQuery);
              }
            }}
            onChange={(e) => {
              this.searchAndReturnResults(`${e.target.value}`);
            }}
            onBlur={() => this.props.onBlur()}
            value={this.state.searchQuery}
            type="text"
            name=""
            id={`phu-fuzzy-search-${uniqueDate}`}
            placeholder={this.props.searchLabel}
            className="ontario-input ontario-margin-bottom-0-!"
            //autoComplete="off"
            autoComplete="chrome-off"
          />
          {this.state.searchQuery && (
            <button className="clear-btn" onClick={this.clearSearch}>
              <CloseIcon className="closeIcon" />
            </button>
          )}
        </div>
      </div>
    );
  }
}

FuzySearch.defaultProps = {
  minSearchLength: 2,
  searchQuery: '',
  searchOnFocus: true,
  searchResultsStartCallback: noop,
  onFocus: noop,
  onBlur: noop,
};

export default FuzySearch;
